import styled, { css } from 'styled-components';

export const DataItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  max-width: 90px;
`;

export const ItemTitle = styled.h5`
  text-align: center;
  font-size: 0.8rem;
  color: var(--tertiary-font-color);
  text-transform: uppercase;
  white-space: nowrap;
`;

export const ItemContent = styled.div`
  ${({ theme: { fontWeight, spacing } }) => css`
    font-weight: ${fontWeight.partBold};

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    gap: ${spacing.xs};
  `}
`;

export const DataContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-around;
  gap: 8px;
  padding: 12px 4px;
  border-bottom: var(--primary-border);
`;
